import config from '../../configs/envs';

const settings =
  typeof process.env.settings === 'object' ? process.env.settings : (config.settings as Settings);

export default settings;
